// extracted by mini-css-extract-plugin
export default {"TopBanner":"TopBanner-module__TopBanner--ypviF"};